import { get } from '../common/cache';
import { postMessageOnParentWindow } from '../common/postMessage';
import constants from './constants';
import common from '../common/common';

const payload = (data, head) => {
  data.mid = get(constants.MID);
  let defaultHead = {
    version: 'v1',
    requestTimestamp: new Date().getTime(),
    token: get(constants.TOKEN)
  };
  return {
    head: head || defaultHead,
    body: data
  };
};
export const post = (url, data, head, postOnUMP = true) => {
  data = payload(data, head);
  common.log('preAPICall', url, { data });
  return fetch(url, {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify(data)
  })
    .then(response => {
      return response.json();
    })
    .then(data => {
      if (data && data.body) {
        return new Promise((res, rej) => {
          if (data.body.resultInfo.resultStatus === 'S') {
            try {
              common.log('postAPICall', 'Success', { url, data });
              if (postOnUMP) {
                postMessageOnParentWindow(data);
              }
            } catch (err) {
              //
            }
            res(data);
          } else {
            common.log('postAPICall', 'Failure', { url, data });
            rej(data);
          }
        });
      }
      common.log('postAPICall', 'Failure', { url, data });
      return Promise.reject(data);
    })
    .catch(error => {
      try {
        common.log('postAPICall', 'Failure', { url, error });
        if (postOnUMP) {
          postMessageOnParentWindow(error);
        }
      } catch (err) {
        //
      }
      return Promise.reject(error.body);
    });
};

export const postWithMultipartFormData = (url, file, postOnUMP = true) => {
  common.log('preAPICall', url, { file });

  const formData = new FormData();
  formData.append('file', file)

  return fetch(url, {
    method: 'POST',
    headers: {},
    credentials: 'same-origin',
    body: formData
  })
    .then(response => {
      return response.json();
    })
    .then(data => {
      if (data && data.body) {
        return new Promise((res, rej) => {
          if (data.body.resultInfo.resultStatus === 'S') {
            try {
              common.log('postAPICall', 'Success', { url, data });
              if (postOnUMP) {
                postMessageOnParentWindow(data);
              }
            } catch (err) {
              //
            }
            res(data);
          } else {
            common.log('postAPICall', 'Failure', { url, data });
            rej(data);
          }
        });
      }
      common.log('postAPICall', 'Failure', { url, data });
      return Promise.reject(data);
    })
    .catch(error => {
      try {
        common.log('postAPICall', 'Failure', { url, error });
        if (postOnUMP) {
          postMessageOnParentWindow(error);
        }
      } catch (err) {
        //
      }
      return Promise.reject(error.body);
    });
};


// WEBPACK FOOTER //
// ./utils/http.js